import React, { useState, useEffect } from 'react';
import './Navbar.css';

// Define the reusable handleScrollToSection function outside the component
export const handleScrollToSection = (sectionId) => {
  document.getElementById(sectionId).scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });

  if (sectionId === 'about') {
    window.history.replaceState(null, null, ' ');
  } else {
    window.history.replaceState(null, null, `#${sectionId}`);
  }
};

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('about');
  const [scrollOverride, setScrollOverride] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollOverride) return;

      const sections = [
        { id: 'about', element: document.getElementById('about') },
        { id: 'publications', element: document.getElementById('publications') },
        { id: 'professional-experience', element: document.getElementById('professional-experience') },
        { id: 'academic-experience', element: document.getElementById('academic-experience') },
        { id: 'awards', element: document.getElementById('awards') },
        { id: 'resume', element: document.getElementById('resume') },
      ];

      const scrollPosition = window.scrollY + 200;

      let currentSection = 'about';
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section.element && scrollPosition >= section.element.offsetTop) {
          currentSection = section.id;
          break;
        }
      }

      if (currentSection !== activeSection) {
        setActiveSection(currentSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeSection, scrollOverride]);

  const handleButtonScroll = (sectionId) => {
    setScrollOverride(true);
    handleScrollToSection(sectionId);
    setActiveSection(sectionId);
    setTimeout(() => setScrollOverride(false), 1000);
    setIsMenuOpen(false); // Close the menu on mobile after clicking
  };

  return (
    <nav className="navbar">
      <button className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        ☰ tgoncalv
      </button>
      <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        <button
          className={activeSection === 'about' ? 'active' : ''}
          onClick={() => handleButtonScroll('about')}
        >
          Bio
        </button>
        <button
          className={activeSection === 'publications' ? 'active' : ''}
          onClick={() => handleButtonScroll('publications')}
        >
          Publications
        </button>
        <button
          className={activeSection === 'professional-experience' ? 'active' : ''}
          onClick={() => handleButtonScroll('professional-experience')}
        >
          Professional Experience
        </button>
        <button
          className={activeSection === 'academic-experience' ? 'active' : ''}
          onClick={() => handleButtonScroll('academic-experience')}
        >
          Academic Experience
        </button>
        <button
          className={activeSection === 'awards' ? 'active' : ''}
          onClick={() => handleButtonScroll('awards')}
        >
          Awards
        </button>
        <button
          className={activeSection === 'resume' ? 'active' : ''}
          onClick={() => handleButtonScroll('resume')}
        >
          Resume
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
